import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useLogUserPaymentCardCancellationMutation } from "@features/userDetails/userDetailsApi.ts";
import { ChangeUserPaymentCardParameters } from "@features/userDetails/types.ts";

export default function ChangePaymentCardCancel() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [mutation, { isLoading, isSuccess, isError }] =
    useLogUserPaymentCardCancellationMutation(undefined);

  useEffect(() => {
    if ([...searchParams].length === 0) {
      return;
    }

    const data: ChangeUserPaymentCardParameters = {
      "checkout-account": searchParams.get("checkout-account") ?? "",
      "checkout-status": searchParams.get("checkout-status") ?? "",
      "checkout-tokenization-id":
        searchParams.get("checkout-tokenization-id") ?? "",
      "checkout-algorithm": searchParams.get("checkout-algorithm") ?? "",
      "checkout-method": searchParams.get("checkout-method") ?? "",
      signature: searchParams.get("signature") ?? "",
    };
    void mutation(data);
  }, [mutation, searchParams]);

  useEffect(() => {
    if (isSuccess) {
      setSearchParams({});
    }
  }, [isSuccess, isError, setSearchParams]);

  return (
    <Stack spacing={3} padding={2}>
      <Stack spacing={2}>
        <Typography variant="h4">
          {t("paymentCardChangeCancel.title")}
        </Typography>
        {isLoading && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        )}
        <Alert severity="warning">{t("paymentCardChangeCancel.text")}</Alert>
      </Stack>
    </Stack>
  );
}
